import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Chip, Stack, Typography } from '@mui/material';

import type { DraftSummaryItem } from './buildDraftSummary';

interface Props {
  item: DraftSummaryItem;
}

export default function DraftSummaryItemAccordion({ item }: Props) {
  return (
    <Accordion variant="outlined" disableGutters key={item.status ?? 'idle'} defaultExpanded={item.status === 'error'}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap" useFlexGap>
          <Typography variant="body2">{item.primary}</Typography>
          {item.secondary && (
            <Typography variant="caption" color="text.secondary">
              {item.secondary}
            </Typography>
          )}
          {item.status === 'success' && <Chip label="Passed" color="success" size="small" variant="outlined" />}
          {item.status === 'error' && <Chip label="Failed" color="error" size="small" variant="outlined" />}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={0.5}>
          {item.details.map((detail) => (
            <Stack key={detail.label} direction="row" justifyContent="space-between" spacing={2}>
              <Typography variant="caption" color="text.secondary">
                {detail.label}
              </Typography>
              <Typography variant="caption" sx={{ textAlign: 'right' }}>
                {detail.value}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
